import { CloudUploadOutlined } from "@ant-design/icons";
import { Button, message, Modal, Select, Tooltip } from "antd";
import Dragger from "antd/es/upload/Dragger";
import React, { FC, useEffect, useState } from "react";
import "./IHXTemplateCSS.css";
import { IUploadReferral } from "../../../interfaces/IReferral";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import { UploadDocument } from "../../../models/EnhancementSlice";
import {
  enhancementService,
  getAllDocumentsData,
  getAllStarhealthDocumentsData,
} from "../../../apis/patientService";
import { getDocuments } from "../../../apis/schemeService";
import { errorMessage } from "../../../utils/notificationUtils";
import FilePreviewModal from "../PreAuth-query/FilePreviewModal";

interface UploadDocumentInPreAuthProps {
  visible: boolean;
  onCancel: () => void;
  documentTypes: any;
  setDocumentTypes: any;
  setDocumentUrls: any;
}

interface Document {
  id: number;
  type?: string;
  file?: any;
  documentId?: any;
  label?: string;
  labelId?: string | number;
  documentUniqueCode?: string;
}

const UploadDocumentInPreAuth: FC<UploadDocumentInPreAuthProps> = ({
  visible,
  onCancel,
  documentTypes,
  setDocumentTypes,
  setDocumentUrls,
}) => {
  const { patients, auth, hospital, enhancement, preAuthClaim } = useSelector(
    (state: RootState) => state
  );

  const dispatch = useDispatch<AppDispatch>();

  const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
  const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;

  useEffect(() => {
    const fetchData = async () => {
      if (caseId && visitId) {
        if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
          const portalMetaData = await enhancementService.getPortalMetaData(
            patients.fetchBasicDetails.casesResponse.schemeMetaDataId
          );
          if (
            portalMetaData.portalMetaDataIdsList &&
            portalMetaData.portalMetaDataIdsList.length > 0
          ) {
            setPortalMetaDataId(portalMetaData.portalMetaDataIdsList[0]);
          }
        }
      }
    };

    fetchData();
  }, [dispatch, caseId, visitId]);

  const [loading, setLoading] = useState<boolean>(true);
  const [portalMetaDataId, setPortalMetaDataId] = useState<number>(0);
  const schemeMetaDataId =
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;

  //   const fetchDocuments = async () => {
  //     if (schemeMetaDataId && caseId && visitId) {
  //       try {
  //         setLoading(true);
  //         const AllDocumentList = await getAllStarhealthDocumentsData(
  //           caseId,
  //           visitId,
  //           schemeMetaDataId
  //         );
  //         setDocumentTypes(AllDocumentList?.["PreAuth"]);
  //       } catch (err) {
  //         errorMessage("Please, Try again after sometime");
  //       } finally {
  //         setLoading(false);
  //       }
  //     }
  //   };

  //   useEffect(() => {
  //     fetchDocuments();
  //   }, [schemeMetaDataId]);

  const [documents, setDocuments] = useState<Document[]>([
    { id: 1, type: undefined, file: undefined },
  ]);

  const [uploadFileModal, setUploadFileModal] = useState<boolean>(false);
  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
  });

  const [selectedFile, setSelectedFile] = useState<IUploadReferral>({
    file: {},
    documentType: "",
  });

  const handleTypeChange = (
    value: string,
    index: number,
    documentId?: any
  ): void => {
    const updatedDocs = [...documents];
    updatedDocs[index] = {
      ...updatedDocs[index],
      type: value?.split("~")?.[0],
      documentId: documentId,
      documentUniqueCode: value?.split("~")?.[1]
    };
    setDocuments(updatedDocs);
  };

  const handleFileChange = (file: any, index: number): void => {
    const updatedDocs = [...documents];
    updatedDocs[index].file = file;

    setSelectedFile({
      file: file,
      documentType: updatedDocs[index]?.type || "OTHERS",
    });

    setPreviewFile({
      url: URL.createObjectURL(file),
      name: file.name,
      showUpload: true,
    });

    setDocuments(updatedDocs);
    setUploadFileModal(true);
  };

  const uploadProps = {
    name: "file",
    multiple: false,
  };

  const handleUpload = async () => {
    const CollectPostData = new FormData();

    if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      CollectPostData.append(
        "hospitalId",
        patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.patientResponse?.id) {
      CollectPostData.append(
        "patientId",
        patients?.fetchBasicDetails?.patientResponse?.id?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      CollectPostData.append(
        "caseId",
        patients?.fetchBasicDetails?.casesResponse?.id.toString()
      );
    }
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      CollectPostData.append(
        "visitId",
        patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
      );
    }

    const currentDocument = documents.find(
      (doc) => doc.file === selectedFile.file
    );

    CollectPostData.append("documentType", currentDocument?.type || "OTHERS");

    if (selectedFile?.file) {
      CollectPostData.append("file", selectedFile?.file);
    }

    try {
      const resp = await dispatch(
        UploadDocument({
          formData: CollectPostData,
          accessToken: auth.accessToken || "",
        })
      ).unwrap();

      if (resp?.length > 0) {
        message.success(`${resp?.[0]?.documentLabelType} uploaded successfully`);
        setDocumentUrls((prev: any) => [
          ...prev,
          ...resp
        ]);

        setUploadFileModal(false);
      } else {
        message.error("Please Upload Again");
      }
    } catch (error) {
      console.error("Failed to upload document:", error);
      message.error("Failed to upload document. Please try again.");
    } finally {
      setDocuments([
        { id: 1, type: undefined, file: undefined },
      ])
    }
  };

  return (
    <div className="eww">
      <Modal
        open={visible}
        onCancel={onCancel}
        centered
        width={700}
        footer={null}
      >
        <div style={{ marginBottom: "20px" }}>
          <h3
            style={{ fontWeight: 700, fontSize: "14px", marginBottom: "15px" }}
          >
            Upload Documents
          </h3>
          <div
            style={{
              border: "0.1px solid rgb(217, 217, 217)",
              borderRadius: "10px",
              padding: "17px",
              backgroundColor: "#FFFFFF",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <label style={{ flex: 1, fontWeight: 700 }}>
                Select Document Type:
              </label>
              <Select
                style={{ width: "50%" }}
                placeholder="Document Type"
                value={documents?.[0]?.type ? (documents?.[0]?.type + "~" + documents?.[0]?.documentUniqueCode) : null}
                onChange={(value, option) => {
                  const selectedOption = Array.isArray(option)
                    ? option[0]
                    : option;
                  handleTypeChange(
                    value as string,
                    0,
                    selectedOption?.key as string
                  );
                }}
              >
                {documentTypes?.map((document: any) => (
                  <Select.Option key={document.id} value={document.labelId + "~" + document?.documentUniqueCode}>
                    {document.label}
                  </Select.Option>
                ))}
              </Select>
            </div>

            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "1rem",
                  fontWeight: 700,
                }}
              >
                Select File:
              </label>

              <Dragger
                {...uploadProps}
                disabled={!documents[0]?.type}
                style={{
                  borderRadius: "10px",
                  border: "1px dashed #008B8B",
                  padding: "16px 24px",
                  background: "#fff",
                }}
                beforeUpload={() => false}
                showUploadList={false}
                onChange={(info) => {
                  const file = info.file; // RcFile | undefined

                  if (file) {
                    handleFileChange(file, 0);
                  } else {
                    console.error("No file found in originFileObj");
                  }
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                >
                  <CloudUploadOutlined
                    style={{
                      color: "#008B8B",
                      fontSize: "30px",
                      marginRight: "20px",
                    }}
                  />
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "#000",
                        }}
                      >
                        Drag & Drop File or{" "}
                        <a
                          style={{
                            color: "#008B8B",
                            textDecoration: "underline",
                          }}
                        >
                          Browse file
                        </a>
                      </span>
                    </div>

                    <p
                      className="ant-upload-hint"
                      style={{
                        color: "#8c8c8c",
                        fontSize: "13px",
                        margin: 0,
                        textTransform: "initial",
                      }}
                    >
                      (jpeg, png, gif, bmp, wemp, pdf)
                    </p>
                  </div>
                </div>
              </Dragger>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div
              style={{
                width: "13%",
                marginTop: "4%",
                display: "flex",
                justifyContent: "center",
                //   alignItems:"center",
              }}
            >
              <Button
                type="primary"
                style={{
                  backgroundColor: "#008B8B",
                  color: "#fff",
                  boxShadow: "0px 2px 8px 0px #00000040",
                  width: "100%",
                }}
                onClick={() => onCancel()}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
        <FilePreviewModal
          isVisible={uploadFileModal}
          onClose={() => setUploadFileModal(false)}
          fileUrl={previewFile.url}
          fileName={previewFile.name}
          // documentType={previewFile.documentType}
          handleUpload={handleUpload}
          showUploadButton={previewFile.showUpload}
          key={selectedFile?.file?.uid || "no-file"}
          isLoading={enhancement?.isLoading}
        />
      </Modal>
    </div>
  );
};

export default UploadDocumentInPreAuth;
